export default {
    fade: {
        origin: { opacity: 0 },
        destination: { opacity: 1 },
    },
    "fade-up": {
        origin: { opacity: 0, yPercent: 10 },
        destination: { opacity: 1, yPercent: 0 },
    },
};
